<template>
  <div class="home">
    <!-- 首页顶部导航 -->
    <div v-if="bannersListShow && bannersList && bannersList.length > 0" class="home-nav-bg">
      <el-carousel autoplay :interval=5000 height="25vw" class="nav-box">
        <el-carousel-item
          v-for="(item,index) in bannersList"
          :key="index"
          class="nav-img"
          :style="{'background-image': 'url(' + item.picture + ')'}"
        >
          <div class="video-btn" v-if="item.type === 'video' && item.link" @click="watchDetail(item.link)">
          </div>
          <div class="zhezhao" v-if="item.type === 'video' && item.link" @click="watchDetail(item.link)" />
          <a class="zhezhao" v-if="item.type === 'link' && item.link"  :href="item.link"  target="_blank" />
        </el-carousel-item>
      </el-carousel>
    </div>

    <div v-else-if="bannersListShow || bannersList.length <= 0" class="home-nav-bg">
      <div class="nav-box">
        <div class="nav-img" style="background-image: url(https://xfjoss.coli688.com/pc-images/banner.png)" />
      </div>
    </div>

    <div class="home-con-box">
      <div class="home-con">
        <div class="nav-search">
          <project-search ui-type="max"/>
        </div>
        <div style="display: flex; justify-content: space-between;">
           <!-- 城市精品 -->
          <div class="home-con-item">
            <div class="item-head">
              <div class="item-tit">
                <img alt="icon" src="https://xfjoss.coli688.com/pc-images/header-icon.png"/>
                <span class="title" title="城市精品">城市精品</span>
              </div>
            </div>
            <el-carousel v-if="boutiqueList && boutiqueList.length > 0" autoplay :interval=5000 height="820px" class="item-carousel">
              <el-carousel-item v-for="(item,index) in boutiqueList" :key="index" class="project-carousel">
                <div class="video-btn" v-if="item.type === 'video' && item.link" @click="watchDetail(item.link)">
                  <!-- <i class="el-icon-arrow-right"/> -->
                </div>
                <img v-if="item.type === 'video' && item.link" class="project-img" :src="item.picture" @click="watchDetail(item.link)" />
                <a v-if="item.type === 'link' && item.link"  :href=item.link  target="_blank"><img  class="project-img" :src="item.picture" /></a>
                <img v-else class="project-img" :src="item.picture" />
                <!-- <img v-else class="project-img" :src="item.picture" @click="watchDetail(item.link)" /> -->
              </el-carousel-item>
            </el-carousel>
            <div v-else>
              <div class="item-carousel project-carousel">
                <img
                  style="height: 820px; width: 580px"
                  class="project-img"
                  alt="城市精品"
                  src="https://xfjoss.coli688.com/pc-images/default-city-select.jpg"
                />
              </div>
            </div>
          </div>
          <!-- 热卖好房 -->
          <div class="home-con-item">
            <div class="item-head">
              <div class="item-tit">
                <img alt="icon" src="https://xfjoss.coli688.com/pc-images/header-icon.png"/>
                <span class="title" title="热卖好房">热卖好房</span>
              </div>
              <div class="item-head-right" v-if="projectShow">
                <div class="item-more" @click="goNewHouse">
                  查看更多 <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
            <div class="item-project">
              <div class="project-list" v-if="projectShow">
                <div class="project-item" v-for="(projectItem, index) in projectList" :key="index">
                  <project-card :project-info="projectItem"  @shapanDetail="shapanDetail" />
                </div>
              </div>
              <!-- <div v-else>
                <el-empty description="暂时还没有精选好房"></el-empty>
              </div> -->
              <div v-else class="item-empty">
                <img alt="暂时还没有精选好房" src="https://xfjoss.coli688.com/pc-images/palceholder.png"/>
                <div class="item-empty-title">暂时还没有精选好房</div>
              </div>
            </div>
          </div>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <!-- 热门活动 -->
          <div class="home-con-item">
            <div class="item-head">
              <div class="item-tit">
                <img alt="icon" src="https://xfjoss.coli688.com/pc-images/header-icon.png"/>
                <span class="title" title="热门活动">热门活动</span>
              </div>
              <div class="item-head-right" v-if="activityShow">
                <div :class="['right-back',{active:!leftBtnShow}]" style="margin-right:20px" @click="onLeft">
                  <i class="el-icon-arrow-left"></i>
                </div>
                <span class="item-word">{{activityIndex/2+1}}/{{Math.round(activityNum/2)}}</span>
                <div :class="['right-back',{active:!rightBtnShow}]" @click="onRight">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
            <div class="item-activity-box">
              <div id="activity" class="item-activity" v-if="activityShow">
                <activity-com
                  class="hot-activity"
                  v-for="(activityItem, index) in activityList"
                  :key="index"
                  :activity-info="activityItem"
                />
              </div>
              <!-- <div v-else>
                <el-empty description="暂时还没有热门活动"></el-empty>
              </div> -->
              <div v-else class="item-empty">
                <img alt="暂时还没有热门活动" src="https://xfjoss.coli688.com/pc-images/palceholder.png"/>
                <div class="item-empty-title">暂时还没有热门活动</div>
              </div>
            </div>
          </div>
          <!-- 热门直播 -->
          <div class="home-con-item">
            <div class="item-head">
              <div class="item-tit">
                <img alt="icon" src="https://xfjoss.coli688.com/pc-images/header-icon.png"/>
                <span class="title" title="热门直播">热门直播</span>
              </div>
              <div class="item-head-right" v-if="liveShow">
                <div :class="['right-back',{active:!leftLiverBtnShow}]" style="margin-right:20px" @click="onLiverLeft">
                  <i class="el-icon-arrow-left"></i>
                </div>
                <span class="item-word">{{liverIndex/2+1}}/{{Math.round(liverNum/2)}}</span>
                <div :class="['right-back',{active:!rightLiverBtnShow}]" @click="onLiverRight">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
            <div class="item-activity-box">
              <div id="liver" class="item-activity" v-if="liveShow">
                <popular-live
                  class="hot-activity2"
                  v-for="(activityItem, index) in liveList"
                  :key="index"
                  :activity-info="activityItem"
                />
              </div>
              <div v-else class="item-empty">
                <img alt="暂时还没有热门直播" src="https://xfjoss.coli688.com/pc-images/palceholder.png"/>
                <div class="item-empty-title">暂时还没有热门直播</div>
                <!-- <el-empty description="暂时还没有热门直播"></el-empty> -->
              </div>
            </div>
          </div>

        </div>

        <div class="home-con-item home-con-item-header">
            <div class="item-head">
              <div class="item-tit">
                <img alt="icon" src="https://xfjoss.coli688.com/pc-images/header-icon.png"/>
                <span class="title" title="中海头条">中海头条</span>
              </div>
              <div class="item-head-right" v-if="projectShow">
                <div class="item-more" @click="goHeadLine">
                  查看更多 <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
            <!-- <div class="item-project">
              <div class="project-list" v-if="projectShow">
                <div class="project-item" v-for="(projectItem, index) in projectList" :key="index">
                  <project-card :project-info="projectItem"/>
                </div>
              </div>
              <div v-else>
                <el-empty description="暂时还没有精选好房"></el-empty>
              </div>
            </div> -->

            <div class="headline-section">
              <div class="headline-wrap">
                <div class="type-list">
                  <div class="type" :class="{active: active === i}" v-for="(item, i) in headLineDictList" :key="i" @click="changeType(item, i)">{{ item.label }}</div>
                </div>
                <div v-if="headlineObj.list && headlineObj.list.length > 0" class="article-list">
                  <headLineComCard v-for="(item, i) in headlineObj.list" :showBorder="i !== headlineObj.list.length - 1" :key="i" :content="item" />
                </div>
                <div v-else class="item-empty item-empty-headline">
                  <img alt="暂时还没有头条" src="https://xfjoss.coli688.com/pc-images/palceholder.png"/>
                  <div class="item-empty-title">暂时还没有头条</div>
                </div>
              </div>
            </div>

          </div>
          <pop-dialog :show.sync="dialogVisible" class="pop-dialog-wrap">
            <!-- <div class="video-prev" @click="preVideo">
              <i class="el-icon-arrow-left"></i>
            </div> -->
            <video  ref="vueRef"  controls preload style="height: 100%; width:100% ;" :src="activeVideoInfo"/>
            <!-- <div class="video-next" @click="nextVideo">
              <i class="el-icon-arrow-right"></i>
            </div> -->
          </pop-dialog>
          <a target="_blank" :href="vrUrl"><span id="tag"></span></a>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectCard from "./components/ProjectCard.vue"
import ActivityCom from './components/activityCard.vue'
import popularLive from './components/popularLive.vue'
import { mapGetters } from 'vuex'
import headLineComCard from './components/headLineComCard.vue'
import ProjectSearch from "@/components/ProjectSearch.vue"
import popDialog from '../projectDetail/components/ProjectPicture/PopDialog.vue'
import swTracker from '@/mixins/tracker.js'

export default {
  name: "HomeView",
  mixins: [swTracker],
  components: {
    ActivityCom,
    ProjectCard,
    ProjectSearch,
    headLineComCard,
    popularLive,
    popDialog,
  },
  data () {
    return {
      projectList: [], // 获取精选好房
      activityDict: {
        1: 'lottery',
        2: 'common',
        3: 'getLikes',
        4: 'vote',
        5: 'bargain',
        6: 'group',
        7: 'activitySquare',
      },
      activityList: [], // 热门活动
      liveList: [], //热门直播
      activityNum: 0,
      activityIndex: 0,
      liverNum: 0,
      liverIndex: 0,
      bannersList: {}, //轮播图
      boutiqueList: {}, //城市精品
      headLineDictList: [],
      headlineDictId: 4,
      active: 0,
      headlineObj: [],
      headlineObjList: [],
      dialogVisible: false,
      activeVideoInfo: '',
      bannersListShow: false,
      vrUrlDetail: '',
      dialogVrVisible: false,
      vrUrl: '',
    }
  },
  computed: {
    ...mapGetters([
      'homePage',
    ]),
    projectShow () {
      if (this.projectList.length > 0) {
        return true
      } else {
        return false
      }
    },
    activityShow () {
      if (this.activityList.length > 0) {
        return true
      } else {
        return false
      }
    },
    liveShow () {
      if (this.liveList.length > 0) {
        return true
      } else {
        return false
      }
    },
    leftBtnShow () {
      if (this.activityIndex <= 0) {
        return false
      } else {
        return true
      }
    },
    rightBtnShow () {
      if (this.activityIndex <= this.activityNum-3) {
        return true
      } else {
        return false
      }
    },
    leftLiverBtnShow () {
      if (this.liverIndex <= 0) {
        return false
      } else {
        return true
      }
    },
    rightLiverBtnShow () {
      if (this.liverIndex <= this.liverNum-3) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    dialogVisible (val) {
      if(!val) {
        this.$refs.vueRef.pause()
      }
    },
    dialogVrVisible (val) {
      let iframe = document.getElementById("iframeId")
      if(!val) {
        iframe.src = ''
      }else {
        if(iframe) {
          iframe.src = this.vrUrlDetail
        }
      }
    },
    'homePage.id' () {
      this.bannersListShow = false
      this.getChoiceProjectList()
      this.getActivities()
      this.getBanners()
      this.getCityBoutique()

      this.getHeadLineDictList()
      this.getHeadLineList()
      this.getPopularLiveBroadcast()

      setTimeout(() => {
        let activityBox = document.querySelector("#activity")
        if (activityBox) {
          activityBox.style.marginLeft = ""
        }
        this.activityIndex = 0

        let liverBox = document.querySelector("#liver")
        if (liverBox) {
          liverBox.style.marginLeft = ""
        }
        this.liverIndex = 0
        this.bannersListShow = true
      },500)
    },
  },
  created() {
    setTimeout(() => {
      if (this.homePage.id) {
        this.getChoiceProjectList()
        this.getActivities()
        this.getBanners()
        this.getCityBoutique()
        this.getHeadLineDictList()
        
        this.getPopularLiveBroadcast()

        let activityBox = document.querySelector("#activity")
        if (activityBox) {
          activityBox.style.marginLeft = ""
        }
        this.activityIndex = 0

        let liverBox = document.querySelector("#liver")
        if (liverBox) {
          liverBox.style.marginLeft = ""
        }
        this.liverIndex = 0
      }
    }, 500);
  },
  methods: {
    shapanDetail (data, type) {
      this.vrUrl = data
      // const tag = document.getElementById('tag')
      // setTimeout(() => {
      //   tag.click()
      // },250)
      // this.vrUrlDetail = data
      // this.dialogVrVisible = true
      const routeData = this.$router.resolve({
        path: '/vrView',
        query: { vrUrl: this.vrUrl, pageFrom: 'back', type }
      })
      window.open(routeData.href, '_blank')
    },
    changeType (item, i) {
      this.active = i
      this.headlineDictId = item.value
      this.getHeadLineList(1)
    },
    // 获取楼盘头条分类
    async getHeadLineDictList (){
      const params = {
        code: 'headline_type',
        visibleRoleType: 1,
        homePageId: this.homePage.id
      }
      const res = await this.$api.getHeadLineDictList(params)
      let headLineDictList = []
      if (res.code === 200) {
        headLineDictList = res.data || []
        headLineDictList = headLineDictList.map((item) => {
          return {
            label: item.name,
            value: item.id,
          }
        })  
      }
      // if(headLineDictList.length !== 4) {
      //   this.headLineDictList = [
      //     {
      //       "label": "品牌力",
      //       "value": 4
      //     },
      //     {
      //       "label": "城市观",
      //       "value": 5
      //     },
      //     {
      //       "label": "产品力",
      //       "value": 6
      //     },
      //     {
      //       "label": "生活观",
      //       "value": 7
      //     }
      //   ]
      // }else {
      this.headLineDictList = headLineDictList
      this.active = 0
      this.headlineDictId = this.headLineDictList[0].value
      this.getHeadLineList()
      // }
      // headLineDictList.unshift({ label:'全部', value: -1 })
    },
    getHeadLineList (page) {
      const headlineDictId = this.headlineDictId
      let params = {
        visibleRoleType: 1,
        headlineDictId: headlineDictId === -1 ? null : headlineDictId,
        page: page || 1,
        limit: 4,
        homePageId: this.homePage.id
      }
      this.$api.getHeadLineList(params).then(res => {
        if (res.code === 200) {
          this.headlineObj = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    currentChange (val) {
      this.getHeadLineList(val)
    },
    // 获取热门直播
    getPopularLiveBroadcast(){
    const params = {
      page: 1,
      liveStatus: 103,
      homePageId:this.homePage.id,
    }
    this.$api.getPopularLiveBroadcast(params).then(res => {
      this.liveList = res.data.list || []
      this.liverNum = this.liveList.length
      // if (this.liveList.length > 3) {
      // this.liverNum = (((this.liveList.length) * 220 + (this.liveList.length-1) * 20)-580) / 120
      // }else if (this.liveList.length === 3) {
      //   this.liverNum = 3
      // }else if (this.liveList.length < 3) {
      //   this.liverNum = 2
      // }

     })
    },
     // 获取城市精品
     getCityBoutique(){
      this.boutiqueList = {}

      const params = {
        visibleRoleType: 1,
        position: 6,
        homePageId:this.homePage.id,
      }
      this.$api.getCityBoutique(params).then(res => {
        if(res.data.length) {
          // res.data.forEach(item => {
          //   this.boutiqueList.push(item.picture)
          // })
          this.boutiqueList = res.data;
        }
      })
    },
    watchDetail (item) {
      this.activeVideoInfo = item
      this.dialogVisible = true
    },
    // 获取首页banner
    getBanners(){
      this.bannersList = {}
      const params = {
        visibleRoleType: 1,
        position: 5,
        homePageId:this.homePage.id,
      }
      this.$api.getBanners(params).then(res => {
        this.bannersList = res.data;
        this.bannersListShow = true;
      })
    },
    // 获取精选好房
    getChoiceProjectList(){
      const params = {
        page: 1,
        limit: 4,
        homePageId:this.homePage.id,
      }
      this.$api.getChoiceProjectList(params).then(res => {
        this.projectList = res.data.list || []
      })
    },
    // 获取热门活动
    getActivities(){
      const params = {
        page: 1,
        limit: 10,
        homePageId:this.homePage.id,
        activityStatus: '0,1,2',
        locationId: 100,
      }
      this.$api.getActivities(params).then(res => {
        let activityList = res.data.list || []
        activityList = activityList.map(item => {
          item.exhibitionActivityType = this.activityDict[item.exhibitionActivityType]
          switch (item.exhibitionActivityType) {
            case 'common':
              item.page = `exhibitionHall/activity/detail?code=${item.activityCode}&projectCode=${item.projectCode}`
              break
            case 'lottery':
              item.name = item.activityName
              item.coverPicture = item.coverPic
              item.page = `/pages/common/lottery/bootsLottery/index?activityId=${item.activityId}&projectCode=${item.projectCode}`
              break
            case 'getLikes':
              item = {
                ...item.baseInfo,
                coverPicture: item.resource.coverPic,
                startTime: item.baseInfo.startAt,
                endTime: item.baseInfo.endAt,
                name: item.baseInfo.activityName,
                exhibitionActivityType: 'getLikes',
              }
              item.page = `/pages/common/getLikes/index?id=${item.code}`
              break
            case 'bargain':
              item.coverPicture = item.adviserCoverPic
              item.page = `/pages/common/bargain/index?bargainActivityId=${item.id}&projectCode=${item.projectCode}`
              break
            case 'group':
              item = {
                ...item,
                name: item.activityName,
                page: `/pages/common/groupActivity/index?code=${item.code}&projectCode=${item.projectCode}`,
                startTime: item.startAt,
                endTime: item.endAt,
              }
              break
            case 'vote':
              item.coverPicture = item.entranceImg
              item.page = `/pages/votingActivities/activitie?id=${item.id}&projectCode=${item.projectCode}`
              break
            case 'activitySquare':
              item.name = item.activityName
              item.page = `/pages/common/activity/index?landingPageId=${item.activityId}&projectCode=${item.projectCode}`
              break
            default:
              item.name = item.activityName || item.name
              break
          }
          return item
        })
        this.activityList = activityList
        this.activityNum = this.activityList.length
      })
    },
    // 精选好房查看更多
    goNewHouse(){
      this.$router.push({ path: '/newHouse' })
    },
    // 中海头条查看更多
    goHeadLine(){
      this.$router.push({ path: '/headLine' })
    },
    onLeft(){
      if(!this.leftBtnShow){
        return
      }
      this.activityIndex = this.activityIndex - 2
      let activityBox = document.querySelector("#activity")
      activityBox.style.marginLeft = -300*this.activityIndex+"px";
    },
    onRight(){
      if(!this.rightBtnShow){
        return
      }
      this.activityIndex = this.activityIndex + 2
      let activityBox = document.querySelector("#activity")
      activityBox.style.marginLeft = -300*this.activityIndex+"px";
    },
    onLiverLeft(){
      if(!this.leftLiverBtnShow){
        return
      }
      this.liverIndex = this.liverIndex - 2
      let activityBox = document.querySelector("#liver")
      activityBox.style.marginLeft = -300*this.liverIndex+"px";
    },
    onLiverRight(){
      if(!this.rightLiverBtnShow){
        return
      }
      this.liverIndex = this.liverIndex + 2
      let activityBox = document.querySelector("#liver")
      activityBox.style.marginLeft = -300*this.liverIndex+"px";
    }
  },
}
</script>
<style lang="scss" scoped>
/* For demo */

@import "./home";
.headline-section{
    background: white;
    .headline-wrap{
      width: 1180px;
      margin: 0 auto;
      overflow: hidden;
      .type-list{
        width: 100%;
        height: 54px;
        // border-bottom: 1px solid #BDA26C;
        // margin-top: 24px;
        .type{
          display: inline-block;
          @include font16(400, #333);
          line-height: 54px;
          padding: 0 16px 16px 0px;
          cursor: pointer;
          &:hover{
            color: rgba(189, 162, 108, 1);
          }
        }
        .active{
          // background: #BDA26C;
          // color: white;
          color: #BDA26C;
        }
      }
      .article-list {
        display: flex;
        flex-wrap: wrap;
        margin-top: 10px;
      }
    }
  }
  .head-line-pagination{
    float: right;
    margin: 35px 0 120px;
  }
</style>
